export const useFilterValues = (queryStringValues, filterId) => _.has(queryStringValues, filterId) ? Array.isArray(queryStringValues[filterId]) ? queryStringValues[filterId] : [queryStringValues[filterId]] : false

